var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletCommunications = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#02769D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.374 25.342 8.532 5.4V19.726zM12.598 19.726v11.016l8.532-5.4zM36.322 16.522h-22.14c-.792 0-1.422.594-1.53 1.35l12.6 8.298 12.6-8.298c-.126-.756-.738-1.35-1.53-1.35zM27.916 26.296l-2.232 1.476a.755.755 0 0 1-.432.126.755.755 0 0 1-.432-.126l-2.232-1.476-9.918 6.282c.126.756.738 1.332 1.53 1.332h22.14c.792 0 1.404-.576 1.53-1.332l-9.954-6.282z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletCommunications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-communications.b02979bf1b2c101692e5a7d51c761bbd.svg";